import { TemaReuniaoEnum } from 'graphql/types.generated'
import { MetaRoot } from 'util/metaPath'

import { AtividadeColetivaFormModel } from '../model-atividadeColetiva'
import { isPse } from '../utils-atividadeColetiva'
import { isOnlyEducacaoPermanente } from './utils-atividadeColetivaReuniao'

export const createAtividadeColetivaReuniaoCalculations = (path: MetaRoot<AtividadeColetivaFormModel>) => [
  {
    field: path.atividadePse.saude.absolutePath(),
    updates: {
      [path.localAtividade.outraLocalidade.absolutePath()]: (_, allValues: AtividadeColetivaFormModel) =>
        isPse(allValues) ? null : allValues.localAtividade.outraLocalidade,

      [path.localAtividade.unidadeSaudeLocalAtividade.absolutePath()]: (_, allValues: AtividadeColetivaFormModel) =>
        isPse(allValues) ? null : allValues.localAtividade.unidadeSaudeLocalAtividade,
    },
  },
  {
    field: path.temasReuniao.absolutePath(),
    updates: {
      [path.temasSaude.absolutePath()]: (temasReuniaoValue: TemaReuniaoEnum[], allValues: AtividadeColetivaFormModel) =>
        isOnlyEducacaoPermanente(temasReuniaoValue) ? allValues.temasSaude : [],
    },
  },
]
